import { Box, Typography } from '@mui/material';
import React from 'react';
import { i18n } from '../../../../i18n/i18n';
import { dateFormatter } from '../../../../utils/formatters';
import { InputTypeDisplayName } from '../../../../../investigate/Content/routes/collections/Collection/constants';
import { TuneIcon } from '@cellebrite/saas-ui-icons';
import { COLORS } from '@cellebrite/saas-ui-common';
import _ from 'lodash';
import ChipList from '../../../../components/ChipList/ChipList';

interface MatchesSearchInformationProps {
    searchInformation: any;
}
const MatchesSearchInformation: React.FC<MatchesSearchInformationProps> = ({ searchInformation }) => {
    return (
        <Box>
            <Box
                className="background-color-mst"
                sx={{
                    p: '8px 16px',
                    borderRadius: '8px',
                    display: 'flex',
                    height: 40,
                    whiteSpace: 'nowrap',
                    alignItems: 'center',
                    overflow: 'hidden',
                    width: 'calc(100% + 48px)',
                }}
                data-testid="matches-search-information"
            >
                <Box sx={{ display: 'flex', alignItems: 'center', mr: 7 }}>
                    <Typography className="color-md" variant="s14w500" sx={{ display: 'inline' }}>
                        {i18n.translate('Search results for')}:
                    </Typography>
                    <Typography
                        variant="s14w500"
                        sx={{
                            display: 'inline',
                            ml: 1,
                            maxWidth: '200px',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                        }}
                    >
                        {`${searchInformation.searchTerm}`}
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', width: 0 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
                        <Typography className="color-md" variant="s14w500" sx={{ display: 'inline' }}>
                            {i18n.translate('Search ID')}:
                        </Typography>
                        <Typography variant="s14w500" sx={{ display: 'inline', ml: 1 }}>
                            {searchInformation?.streamId}
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
                        <Typography className="color-md" variant="s14w500" sx={{ display: 'inline' }}>
                            {i18n.translate('Date')}:
                        </Typography>
                        <Typography variant="s14w500" sx={{ display: 'inline', ml: 1 }}>
                            {dateFormatter(searchInformation?.createdOn)}
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', maxWidth: 200 }}>
                        <Typography className="color-md" variant="s14w500" sx={{ display: 'inline' }}>
                            {i18n.translate('Input')}:
                        </Typography>
                        <Typography
                            variant="s14w500"
                            sx={{ display: 'inline', ml: 1, textOverflow: 'ellipsis', overflow: 'hidden' }}
                        >
                            {InputTypeDisplayName[searchInformation?.inputType]}
                        </Typography>
                    </Box>
                </Box>
            </Box>
            {!_.isEmpty(searchInformation.advancedSearchInputs) && (
                <Box
                    className="background-color-mst"
                    sx={{
                        mt: 1,
                        p: '8px 16px',
                        borderRadius: '8px',
                        display: 'flex',
                        minHeight: 40,
                        whiteSpace: 'nowrap',
                        alignItems: 'start',
                        overflow: 'hidden',
                        width: 'calc(100% + 48px)',
                    }}
                    data-testid="matches-search-information"
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <TuneIcon style={{ fill: COLORS.MUTED_DARK }} />
                        <Typography
                            sx={{ ml: '6px', color: COLORS.MUTED_DARK }}
                            variant="s14w500"
                        >{`${i18n.translate('Advanced search')}:`}</Typography>
                    </Box>
                    <Box sx={{ px: 2 }}>
                        <ChipList list={searchInformation.advancedSearchInputs} />
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default MatchesSearchInformation;
